module.exports = __webpack_public_path__ + "static/media/hourglass.f8dc76fe.png";